<template>
    <div>
        <div class="detail-view" v-if="activeHistory">
            <div class="attr-table" id="attr-table">
                <b-row><b-col>{{ $t('vehicle_report.time') }}</b-col><b-col>{{ time }}</b-col></b-row>
                <b-row><b-col>{{ $t('vehicle_report.vehicle_label') }}</b-col><b-col>{{ activeHistory.vehicleLabel }}</b-col></b-row>
                <b-row><b-col>{{ $t('vehicle_report.block') }}</b-col><b-col>{{ activeHistory.blockLabel }}</b-col></b-row>
                <b-row><b-col>{{ $t('vehicle_report.line') }}</b-col><b-col>{{ activeHistory.line }}</b-col></b-row>
                <b-row><b-col>{{ $t('vehicle_report.route') }}</b-col><b-col>{{ activeHistory.route }}</b-col></b-row>
                <b-row><b-col>{{ $t('vehicle_report.destination')}}</b-col><b-col>{{ activeHistory.destination }}</b-col></b-row>
                <p></p>
                <b-row><b-col>{{ $t('map.vehicleHistory.trip_id')}}</b-col><b-col>{{ activeHistory.tripId }}</b-col></b-row>
                <b-row><b-col>{{ $t('map.vehicleHistory.event')}}</b-col><b-col><span v-if="activeHistory.updateType === 'ATSTOP'">At stop</span>
                    <span v-else-if="activeHistory.updateType === 'LEFTSTOP'">Left stop</span></b-col></b-row> 
                <b-row><b-col>{{ $t('vehicle_report.deviation') }}</b-col><b-col>{{ deviation }}</b-col></b-row>
                <b-row><b-col>{{ $t('map.vehicleHistory.current_stop')}}</b-col><b-col>{{ currentStop.name }}</b-col></b-row>   
            </div>
        </div>
    </div>
</template>

<script>
import mapstore from '@/store/map/mapstore'
import moment from 'moment'

export default {
    name: 'VehicleHistoryDetails',
    beforeCreate: function() {
        if (!this.$store.state.mapstore) {
            this.$store.registerModule("mapstore" , mapstore);
        }
    },
    computed: {
        activeHistory: function() {
            return this.$store.state.mapstore.vehicleHistory.activeVehicleHistoryDetails
        },
        deviation: function() {
            if( this.activeHistory.deviation )
                return this.activeHistory.deviation/1000+"s"
            return ""
        },
        time: function() {
            if( this.activeHistory.timestamp ) {
                let time = moment(this.activeHistory.timestamp )
                return time.format("YYYY-MM-DD HH:mm:ss")
            }
            return "";
        },
        currentStop: function() {
            if( this.activeHistory.passingStop ) { 
                return this.activeHistory.passingStop
            }
            return "";
        }
    }
}
</script>

<style scoped lang="scss">

.detail-view {
    max-width: 100%;
    width: 100%;
}

.row {
    max-height: 20px;
    height: 20px;
}

.attr-table {
    width: 95%;
    height: 300px;
    max-height: 300px !important;
    font-size: 80%;
}
</style>